import { LRUCache } from "lru-cache";
import LayerGroup from "ol/layer/Group";
import { isMobileDevice } from "../util/deviceDetectionUtil";
import { isWebGLSupported } from "../util/webGLUtils";
import PostGlacialReboundLayer from "./PostGlacialReboundTileLayer";
export default class PostGlacialReboundLayerGroup {
    layerGroup = new LayerGroup();
    // Store only 5 layers to save memory. Older mobile devices crash if
    // too many layers are loaded.
    layers = new LRUCache({
        max: isMobileDevice() ? 5 : 10,
        dispose: (layer) => {
            this.layerGroup.getLayers().remove(layer.getLayer());
        },
    });
    onMapRenderCompleteOnce;
    settings;
    constructor({ settings, onMapRenderCompleteOnce, }) {
        this.settings = settings;
        this.onMapRenderCompleteOnce = onMapRenderCompleteOnce;
        this.onYearChange();
        this.settings.addEventListerner({
            onYearChange: () => this.onYearChange(),
            onBackgroundMapChange: () => this.onNLSBackgroundMapChange(),
            onZoomChange: () => this.onZoomChange(),
            onLayerOpacityChange: () => this.onLayerOpacityChange(),
        });
    }
    getLayerGroup() {
        return this.layerGroup;
    }
    onYearChange = () => {
        if (!isWebGLSupported()) {
            return;
        }
        const nextYear = this.settings.getYear();
        // Hide all layers if current calendar year is selected.
        // This just shows the NLS base map.
        if (nextYear === new Date().getFullYear()) {
            this.hideAllLayers();
            return;
        }
        const cacheKey = String(nextYear);
        this.settings.setIsLoading(false);
        const nextLayer = this.layers.get(cacheKey);
        if (!nextLayer) {
            this.settings.setIsLoading(true);
            const newLayer = new PostGlacialReboundLayer(nextYear, this.settings);
            this.layers.set(cacheKey, newLayer);
            newLayer.getSource().once("tileloadend", () => {
                this.onMapRenderCompleteOnce?.(() => {
                    this.setLayerVisible(newLayer);
                    this.settings.setIsLoading(false);
                });
            });
            this.layerGroup.getLayers().push(newLayer.getLayer());
        }
        else {
            this.setLayerVisible(nextLayer);
        }
    };
    setLayerVisible = (nextLayer) => {
        nextLayer.getLayer().setVisible(true);
        this.layers.forEach((prevLayer) => {
            if (prevLayer.getYear() !== nextLayer.getYear() &&
                prevLayer.getLayer().isVisible()) {
                prevLayer.getLayer().setVisible(false);
            }
        });
    };
    hideAllLayers = () => {
        this.layers.forEach((layer) => {
            layer.getLayer().setVisible(false);
        });
    };
    onNLSBackgroundMapChange() {
        this.layers.forEach((layer) => {
            layer.updateLayerStyle(this.settings);
        });
    }
    onZoomChange() {
        this.layers.forEach((layer) => {
            layer.updateLayerStyle(this.settings);
        });
    }
    onLayerOpacityChange() {
        this.layers.forEach((layer) => {
            layer.onLayerOpacityChange(this.settings);
        });
    }
}
